import { ConfigProvider, Button, ButtonProps } from '@fuxi/eevee-ui';

const SecondaryButton = ({ ...props }: ButtonProps) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Button: {
            lineWidth: 0,
            defaultBg: 'var(--color-fill-tertiary)',
            defaultHoverBg: 'var(--color-fill-secondary)',
            defaultActiveBg: 'var(--color-fill)',
            defaultColor: 'var(--color-text)',
            defaultHoverColor: 'var(--color-text)',
            defaultActiveColor: 'var(--color-text)',
          },
        },
      }}>
      <Button {...props} />
    </ConfigProvider>
  );
};

export default SecondaryButton;
